import { useMemo } from 'react';
import { useTheme } from '@mui/material';
import { useGetTheme } from '../../../../../hooks/use-get-theme';
import { useSettingBasedOnBreakpoints } from '../../../../../hooks/use-setting-based-on-breakpoints';
import { useAppSelector } from '../../../../../app/hooks';
import { userSelector } from '../../../../../selectors';
import { useEnrollmentPeriodOpenInfo } from '../../../../../hooks/use-get-periods-info/use-enrollment-period/use-enrollment-period-open-info';
import { useGetUserStatesInEnrollment } from '../../../../../hooks/use-get-user-states-in-enrollment';

const useModuleWithImage = () => {
  const theme = useGetTheme();
  const muiTheme = useTheme();
  const { isMobile, getSettingBasedOnBreakpoint } =
    useSettingBasedOnBreakpoints(muiTheme);

  const { terminated: isUserTerminated } = useAppSelector(userSelector);
  const { isEnrollmentOrScheduledEnrollmentOpen } =
    useEnrollmentPeriodOpenInfo();
  const userStates = useGetUserStatesInEnrollment();

  return useMemo(
    () => ({
      theme,
      muiTheme,
      isMobile,
      getSettingBasedOnBreakpoint,
      userStates,
      isEnrollmentOrScheduledEnrollmentOpen,
      isUserTerminated,
    }),
    [
      theme,
      muiTheme,
      isMobile,
      getSettingBasedOnBreakpoint,
      userStates,
      isEnrollmentOrScheduledEnrollmentOpen,
      isUserTerminated,
    ],
  );
};

export default useModuleWithImage;
